import * as React from 'react';

export const useEffectButNotOnMount: typeof React.useEffect = (effectCallback, dependencyArray) => {
  const didMountRef = React.useRef<boolean>(false);

  React.useEffect(() => {
    if (didMountRef.current) {
      return effectCallback();
    } else {
      didMountRef.current = true;
    }
  }, dependencyArray);
};
